import { render, staticRenderFns } from "./PendingPayments.vue?vue&type=template&id=0fb7088c&"
import script from "./PendingPayments.vue?vue&type=script&lang=js&"
export * from "./PendingPayments.vue?vue&type=script&lang=js&"
import style0 from "./PendingPayments.vue?vue&type=style&index=0&id=0fb7088c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports